var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
export var GET_NEWS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetNews {\n    news {\n      id\n      title\n      content\n      publicationStartDate\n    }\n  }\n"], ["\n  query GetNews {\n    news {\n      id\n      title\n      content\n      publicationStartDate\n    }\n  }\n"])));
var templateObject_1;
